import EfSpec from 'elem/ui/ef-spec';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function PageComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rule');

    const list = useMemo(() => {
        const EN_SITE = ['eu', 'za', 'us', 'ca', 'au', 'uk'];
        let str = '';
        if (EN_SITE.includes(locale)) {
            str = `en-${locale}`;
        } else {
            switch (locale) {
                case 'cn':
                    str = 'zh-cn';
                    break;
                case 'tw':
                    str = 'zh-tw';
                    break;
                case 'it': {
                    str = 'it-it';
                    break;
                }
                case 'sa': {
                    str = 'sa';
                    break;
                }
                case 'de': {
                    str = 'de-de';
                    break;
                }
                case 'fr': {
                    str = 'fr-fr';
                    break;
                }
                case 'es': {
                    str = 'es-es';
                    break;
                }
                case 'jp': {
                    str = 'ja-jp';
                    break;
                }
                case 'kr': {
                    str = 'ko-kr';
                    break;
                }
                case 'br': {
                    str = 'pt-br';
                    break;
                }
                case 'mx': {
                    str = 'es-mx';
                    break;
                }
                case 'nl': {
                    str = 'nl-nl';
                    break;
                }
                default: {
                    str = 'en-us';
                    break;
                }
            }
        }

        return [
            {
                title: t('E_list_title1'),
                link: `https://account.ecoflow.com/agreement/${str}/PrivacyPolicy.html`,
            },
            {
                title: t('E_list_title2'),
                link: `https://account.ecoflow.com/agreement/${str}/Statement.html`,
            },
        ];
    }, [locale, t]);
    return (
        <div className={`${css['page-comp']}`}>
            <p className="title">{t('E_title')}</p>
            <ul className="links">
                {list.map((i, idx) => (
                    <a href={i.link} target="_blank" key={idx} rel="noreferrer">
                        <li className="link-item">
                            <div className="link-text">{i.title}</div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                style={{ scale: locale === 'sa' ? '-1' : '1' }}
                            >
                                <path
                                    d="M10.4999 3.01709L15.4999 8.01709L10.4999 13.0171"
                                    stroke="#3F68E0"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M14.5 8.01709H2.5" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                        </li>
                    </a>
                ))}
            </ul>
            <EfSpec />
        </div>
    );
}
